/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import DEVICE_BREAKPOINTS from '../../constants/deviceBreakpoints';

// Saved Configuration Modal:
// Initial state:  undefined
// Open state:     true
// Closed state:   false
type ShowSavedConfigurationModal = undefined | true | false;

interface ContextProps {
  isMobileLayout: boolean,
  windowInnerWidth: number,
  windowInnerHeight: number,
  showHeader: boolean,
  showFooter: boolean,
  showSavedConfigurationModal: ShowSavedConfigurationModal,
  setShowHeader: (showHeader: boolean) => void,
  setShowFooter: (showFooter: boolean) => void,
  setShowSavedConfigurationModal: (showSavedConfigurationModal: ShowSavedConfigurationModal) => void
}

const defaultConfig = {
  isMobileLayout: true,
  windowInnerWidth: 0,
  windowInnerHeight: 0,
  showHeader: true,
  showFooter: true,
  showSavedConfigurationModal: undefined
};

export const ConfigContext = React.createContext<ContextProps>({
  ...defaultConfig
} as ContextProps);

export default function ConfigContextProvider(props) {
  // eslint-disable-next-line react/prop-types
  const { children } = props;
  const [config, setConfig] = useState({ ...defaultConfig });

  const setShowHeader = (showHeader) => { setConfig((config) => ({ ...config, showHeader })); }
  const setShowFooter = (showFooter) => { setConfig((config) => ({ ...config, showFooter })); }
  const setShowSavedConfigurationModal = (showSavedConfigurationModal) => { setConfig((config) => ({ ...config, showSavedConfigurationModal })); }

  // TODO: optimize, it triggers render rapidly on resize, should make use of media query
  useEffect(() => {
    const onResize = () => {
      const isAtMobileDevice = window.innerWidth <= DEVICE_BREAKPOINTS.MOBILE;
      const isAtTabletDevice = window.innerWidth > DEVICE_BREAKPOINTS.MOBILE && window.innerWidth < DEVICE_BREAKPOINTS.LAPTOP;

      setConfig((c) => ({
        ...c,
        isMobileLayout: isAtMobileDevice || isAtTabletDevice,
        windowInnerWidth: window.innerWidth,
        windowInnerHeight: window.innerHeight
      }));
    };

    // Initial setup
    onResize();

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [setConfig])

  return (
    <ConfigContext.Provider value={{
      ...config,
      setShowHeader,
      setShowFooter,
      setShowSavedConfigurationModal
    }}>
      { children }
    </ConfigContext.Provider>
  );
}
